const facilityType = [
    { label: "Primary", value: "primary" },
    { label: "Secondary", value: "secondary" },
    { label: "Tertiary", value: "tertiary" },
]

const presenting_complaint_options =[
    {label: "None", value: "1"},
    {label: "Yes (specify)", value: "2"},
  ];
  

const rednessLeftOptions = [
    { label: 'With pain', value: '1' },
    { label: 'Discharge', value: '2' },
    { label: 'Itchy', value: '3' },
    { label: 'Dry', value: '4' },
];

const rednessRightOptions = [
    { label: 'With pain', value: '1' },
    { label: 'Discharge', value: '2' },
    { label: 'Itchy', value: '3' },
    { label: 'Dry', value: '4' },
];

const visionLossLeftOptions = [
    {label: "Poor distant vision", value: "1"},
    {label: "Poor near vision", value: "2"},
    {label: "Gradual", value: "3"},
    {label: "Sudden", value: "4"},
]

const visionLossRightOptions = [
    {label: "Poor distant vision", value: "1"},
    {label: "Poor near vision", value: "2"},
    {label: "Gradual", value: "3"},
    {label: "Sudden", value: "4"},
];

const sectionBPainLeft = [
    {label: "Severe", value: "1"},
    {label: "Moderate", value: "2"},
    {label: "Mild", value: "3"},
];

const sectionBPainRight = [
    {label: "Severe", value: "1"},
    {label: "Moderate", value: "2"},
    {label: "Mild", value: "3"},

];

const eyeInjuryLeft = [
    {label: "Chemical", value: "1"},
    {label: "Hot liquid/fire", value: "2"},
    {label: "Foreign Body", value: "3"},
    {label: "Blunt force trauma", value: "4"},
]

const eyeInjuryRight = [
    {label: "Chemical", value: "1"},
    {label: "Hot liquid/fire", value: "2"},
    {label: "Foreign Body", value: "3"},
    {label: "Blunt force trauma", value: "4"},
]

const visualDistLeft = [
    {label: "Blurry vision", value: "1"},
    {label: "Tunnel vision", value: "2"},
    {label: "Spots", value: "3"},
]
const visualDistRight = [
    {label: "Blurry vision", value: "1"},
    {label: "Tunnel vision", value: "2"},
    {label: "Spots", value: "3"},
]

const reviewSystemOptions = [
    {label:"Pain", value: "1"},
    {label:"Weight changes", value: "2"},
    {label:"Fatigue/Tiredness", value: "3"},
    {label:"Recurrent skin infections", value: "4"},
    {label:"Slow healing Wound/Ulcer", value: "5"},
    {label:"Numbness or tingling of hands/feet", value: "6"},
]

const pastHistoryComborbidityOpt= [
    {label:"Diabetes", value: "1"},
    {label:"Hypertension", value: "2"},
    {label:"Family History of Diabetes", value: "3"},
    {label:"Stroke/CVA/TIA", value: "4"},
    {label:"Cardiovascular Disease", value: "5"},
    {label:"Dyslipidemia", value: "6"},
    {label:"TB", value: "7"},
    {label:"Chronic Kidney disease", value: "8"},
    {label:"Obesity", value: "9"},
    {label:"HIV", value: "10"},
]

const past_ocular_history_options = [
    {label: "Yes", value: "1"},
    {label: "No", value: "2"},
  ];

const onTreatmentOpt=[
    {label: "Yes", value: "1"},
    {label: "No", value: "2"},
]

const treatmentTypeOption=[
    {label: "Traditional", value: "1"},
    {label: "Conventional", value: "2"},
]

const typeOfDiagnosis=[
    {label:"Type 1", value: "1"},
    {label: "Type 2", value: "2"},
]
const currentMedications=[
    {label:"Yes", value:"yes"},
    {label:"No", value:"no"},
]
const oralMedications=[
    {label:"Oral", value:"Oral"},
    {label:"Injectables", value:"Injectables"},
  ];

const bloodSugarLevels=[
    {label:"Well Controlled", value:"1"},
    {label:"Poorly Controlled", value:"2"},
    {label:"Not Monitored", value:"3"},

]
const riskFactorExerciseOpt=[
    {label:"Very Active", value:"1"},
    {label:"Moderately Active", value:"2"},
    {label:"Somewhat Active", value:"3"},
    {label:"Not Active", value:"4"},
]

const alcohol_user = [
    {label: "Yes", value: "Yes"},
    {label: "No", value: "No"},
  ];
  
  const smoker_user = [
    {label: "Yes", value: "Yes"},
    {label: "No", value: "No"},
  ];

const dietOpt=[
    {label:"Healthy", value:"1"},
    {label:"Unhealthy", value:"2"},
]
const smokerOpt=[
    {label:"Tobacco", value:"tobacco"},
    {label:"Other", value:"others"},
]

const riskRatingOpt = [
    {label: "0 = No current risk", value: "0"},
    {label: "1 = Low risk", value: "1"},
    {label: "2 = Moderate risk", value: "2"},
    {label: "2 = High risk", value: "3"},
    {label: "4 = Emergency", value: "4"},
  ];

const referralOpt=[
    {label: "Yes", value: "1"},
    {label: "No", value: "2"},
    { label: "None", value: "" }
]

const coloBlindnessOption = [
    {label: "", value: "0"},
    {label: "", value: "1"},
    {label: "", value: "2"},
    {label: "", value: "3"},
]

const visualAcuityTest = [
    {label: "", value: "1"},
    {label: "", value: "2"},
    {label: "", value: "3"},
    {label: "", value: "4"},
    {label: "", value: "5"},
    {label: "", value: "6"},
    {label: "", value: "7"},
]

const drGradingRetinopathy=[
    {label: "", value: "0"},
    {label: "", value: "1"},
    {label: "", value: "2"},
    {label: "", value: "3"},
    {label: "", value: "4"},
]

const drOphthalmoscopy=[
    {label: "", value: "1"},
    {label: "", value: "2"},
    {label: "", value: "3"},
    {label: "", value: "4"},
    {label: "", value: "5"},
    {label: "", value: ""},
]

const footSensationOpt = [
    {label: "1", value: "1"},
    {label: "2", value: "2"},
    {label: "3", value: "3"},
    {label: "4", value: "4"},
    {label: "5", value: "5"},
    {label: "6", value: "6"},
    {label: "7", value: "7"},
    {label: "8", value: "8"},
    {label: "9", value: "9"},
    {label: "10", value: "10"},
]


export { rednessLeftOptions,
         rednessRightOptions,
         visionLossLeftOptions,
         visionLossRightOptions,
         sectionBPainLeft,
         sectionBPainRight,
         eyeInjuryLeft,
         eyeInjuryRight,
         visualDistLeft,
         visualDistRight,
         reviewSystemOptions,
         facilityType,
         pastHistoryComborbidityOpt,
         onTreatmentOpt,
         treatmentTypeOption,
         typeOfDiagnosis,
         currentMedications,
         bloodSugarLevels,
         riskFactorExerciseOpt,
         dietOpt,
         smokerOpt,
         riskRatingOpt,
         referralOpt,
         coloBlindnessOption,
         visualAcuityTest,
         drGradingRetinopathy,
         drOphthalmoscopy,
         footSensationOpt,
         presenting_complaint_options,
         past_ocular_history_options,
         oralMedications,
         alcohol_user,
         smoker_user,
        }